app.service('companyName', function () {

	function init(name) {
        window.companyName(name);
	}

	return { init };
});
